

import { Redirect, Switch, useHistory } from 'react-router';

import { Button, ButtonMode } from '@communicare/medications/Components/Button';
import styles from './MedicationList.module.scss';
import { PlusIcon } from '@communicare/medications/Components/Icons';
import { white } from '@communicare/medications/Styles/Colours';
import { MedicationLists } from '@communicare/medications/MedicationLists/MedicationLists';
import { CreateMedicationListDialog } from '@communicare/medications/MedicationLists/CreateMedicationListDialog/CreateMedicationListDialog';
import { MedicationList } from '@communicare/medications/MedicationLists/MedicationList/MedicationList';
import { Route, useRouteMatch } from 'react-router-dom';
import { CommunicareWrapper } from '../communicare-mount/MountCommunicare';

const guidRegex = '[0-9A-Fa-f\\-]{36}';
const createRouteForMedicationList = (baseUrl:string,medListId: string) => `${baseUrl}/view/${medListId}`;

export const MedpointMedicationList = ()=>{
    let history = useHistory();
    let { path, url } = useRouteMatch();
    return (
        <CommunicareWrapper>
            <Switch>
            <Route exact path={path}>
                <Redirect to={{
                    pathname:`${url}/home`
                }}/>
            </Route>
            <div className={styles.container}>
                <Route
                        path={`${path}/view/:medListId`}
                        render={routeParams => {
                            const medListId = routeParams.match.params.medListId;
                            if (medListId)
                                return (
                                    <MedicationList
                                        medListId={medListId}
                                        onDelete={() => {
                                            console.log('NOOP');
                                        }}
                                    />
                                );
                        }}
                />
                <Route path={`${path}/home`}>
                <div className={styles.medicationListWrapper}>
                    <div className={styles.header}>
                        <Button
                            onClick={() => history.push(`${url}/home/new`)}
                            testId='create-medlist'
                            className={styles.addList}
                            startIcon={<PlusIcon size='16' color={white} />}
                        >
                            Add medication list
                        </Button>
                    </div>
                    <MedicationLists
                        onAddMedicationList={() => {
                            history.push(`${url}/home/new`);
                        }}
                        onEditClick={row => {
                            history.push(createRouteForMedicationList(url,row.id));
                        }}
                        filtersActive={false}
                        query=''
                    >
                        {medicationListHelpers => (
                            <Route exact path={`${path}/home/new`}>
                                <CreateMedicationListDialog
                                    onClose={() => {
                                        history.push(url);
                                    }}
                                    onComplete={(id: string) => {
                                        medicationListHelpers.refresh();
                                        history.push(createRouteForMedicationList(url,id));
                                    }}
                                />
                            </Route>
                        )}
                    </MedicationLists>
                </div>
                </Route>
            </div>
            </Switch>
        </CommunicareWrapper>
    );
};